(() => {
  if (window.ehsIrInCompareInstalled) return;
  window.ehsIrInCompareInstalled = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ehs-in-compare]');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#')) return;
    const anchor = document.getElementById(href.slice(1));
    if (!anchor) return;
    const region = anchor.closest('.ehs-ir');
    const id = link.dataset.ehsInCompare;
    if (!region || !id) return;
    let target = null;
    region.querySelectorAll('[data-ehs-in-column]').forEach((cell) => {
      const selected = cell.dataset.ehsInColumn === id;
      cell.classList.toggle('is-selected', selected);
      if (selected && cell.tagName === 'TH') target = cell;
    });
    if (target) {
      const scroller = region.querySelector('.ehs-ir__table-scroll');
      if (scroller) scroller.scrollLeft = Math.max(0, target.offsetLeft - 160);
    }
  });
})();

(() => {
  if (window.ehsIrInRailInstalled) return;
  window.ehsIrInRailInstalled = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ehs-in-slide]');
    if (!button) return;
    const rail = document.getElementById(button.getAttribute('aria-controls'));
    if (!rail) return;
    rail.scrollBy({left: Number(button.dataset.ehsInSlide) * rail.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
})();
